export type EvaluationPlanCategoryScope = 'admin' | 'team' | 'user';

export type EvaluationPlanCategorySelection = {
  scope: EvaluationPlanCategoryScope;
  name: string;
};

export const EMPTY_EVALUATION_PLAN_CATEGORY_SELECTION: EvaluationPlanCategorySelection = {
  scope: 'admin',
  name: '',
};

export function resolveEvaluationPlanCategorySelection(
  prev: EvaluationPlanCategorySelection,
  adminNames: string[],
  personalNames: string[],
  teamNames: string[] = []
): EvaluationPlanCategorySelection {
  const { scope, name } = prev;
  if (name) {
    if (scope === 'admin' && adminNames.includes(name)) return prev;
    if (scope === 'user' && personalNames.includes(name)) return prev;
    if (scope === 'team' && teamNames.includes(name)) return prev;
    if (adminNames.includes(name)) return { scope: 'admin', name };
    if (personalNames.includes(name)) return { scope: 'user', name };
    if (teamNames.includes(name)) return { scope: 'team', name };
  }
  if (adminNames[0]) return { scope: 'admin', name: adminNames[0] };
  if (personalNames[0]) return { scope: 'user', name: personalNames[0] };
  if (teamNames[0]) return { scope: 'team', name: teamNames[0] };
  return EMPTY_EVALUATION_PLAN_CATEGORY_SELECTION;
}
